define('views/modules/setting/business/blocks/payment/payment-list-item',[
    // Libs
    'underscore', 'backbone', 'utils', 'debug', 'moment',
    // services
    'services/i18n',
    'services/user',
    // views
    'views/parts/info-section',
    'views/parts/form/button',
    // templates
    'text!templates/modules/setting/business/blocks/payment/payment-list-item.html'
], function(
    // Libs
    _, Backbone, U, DEBUG, moment,
    // services
    i18n,
    User,
    // views
    VInfoSection,
    VButton,
    // templates
    TPaymentListItem
) {

    var VPaymentListItem = Backbone.Epoxy.View.extend({
        template: TPaymentListItem,

        regions: {
            addPaymentMethod: '.button-add-method',
        },

        initialize: function(opt) {
            this.options = opt || {};

            var modelJSON = this.getModelJSON();

            this.view = {
                info: new VInfoSection({
                    title: "Payments",
                    icon: "sl-icon-wallet",
                    content: this.template,
                    model: modelJSON,
                    hasMembershipPlan: this.selectedPlan !== null,
                    context: this,
                    menu: {
                        init: this.onMenuInit,
                        onClick: this.onActionClick,
                    }
                }),
                addPaymentMethod: new VButton({
                    label: i18n.t('payment:edit_payment_method'),
                    callback: this.onEditMethodAction,
                    context: this,
                    icon: false,
                    class: 'btn-default btn-rounded btn-sm',
                }),
            };

            this.listenTo(this.model, { "sync change:payment": this.onModelChange });
            this.listenTo(User, { "sync": this.onModelChange });

        },

        render: function() {
            var opt = this.options;

            this.assign(this.view.info, this.$el);

            this.generateZones();

            this.assign(this.view.addPaymentMethod, this.zone.$addPaymentMethod);
            this.zone.$addPaymentMethod.toggleClass('hidden', this.model.hasPayment());

            return this;
        },

        refreshView: function() {
            this.assign(this.view.info, this.$el);

            this.generateZones();

            this.assign(this.view.addPaymentMethod, this.zone.$addPaymentMethod);

            this.zone.$addPaymentMethod.toggleClass('hidden', this.modelHasPayment(this.model));
        },

        modelHasPayment: function(model) {
            if (model.hasPayment()) {
                return true;
            } else if (model.changed && model.changed[0]) {
                return model.changed[0].payment != null;
            }
            return false;
        },

        getModelJSON: function() {
            var opt = this.options,
                modelJSON = this.model.toJSON(),
                selectedPlan = this.selectedPlan = this.model.getMembershipPlan();

            if (selectedPlan) {
                var membershipPlan = opt.membershipPlans.findWhere({ name: selectedPlan });
                var currency = this.model.getCurrency();
                var languageCode = User.get('languageCode') === undefined ? 'USD' : User.get('languageCode');
                var daysLeft = moment(this.model.getDueDate()).startOf('day').diff(moment().startOf('day'), 'days') + 1;

                daysLeft = Math.max(0, daysLeft);

                var currencyFormatter = new Intl.NumberFormat(languageCode, {
                    style: 'currency',
                    currency: currency,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });

                modelJSON = _.extend({
                    max_members: membershipPlan.getMaxMembers(),
                    max_coaches: membershipPlan.getMaxCoaches(),
                    price: currencyFormatter.format(membershipPlan.getCurrencies()[currency].price),
                    days_left: daysLeft,
                }, modelJSON);
            }

            return modelJSON;
        },

        onMenuInit: function() {
            var menuActions = new Backbone.Collection();

            var modelAttributes = this.model.attributes;
            if (this.model.hasChanged()) {
                modelAttributes = _.extend(modelAttributes, this.model.changedAttributes()[0]);
            }

            if (this.selectedPlan) {
                menuActions.add([
                    { caption: "payment:modify_plan", icon: "sl-icon-note", callback: this.onModifyPlanAction },
                ]);

                if (modelAttributes.payment !== null) {
                    menuActions.add([
                        { caption: "payment:delete_payment_method", icon: "sl-icon-trash", callback: this.onDeleteMethodAction },
                    ]);
                } else {
                    menuActions.add([
                        { caption: "payment:edit_payment_method", icon: "sl-icon-note", callback: this.onEditMethodAction },
                    ]);
                }

                menuActions.add([
                    { caption: "payment:show_invoice_history", icon: "sl-icon-doc", callback: this.onShowInvoiceHistory },
                ]);

            } else {
                menuActions.add([
                    { caption: "payment:select_plan", icon: "sl-icon-note", callback: this.onModifyPlanAction },
                ]);
            }

            return menuActions;
        },

        onModelChange: function() {
            this.view.info.options.model = this.getModelJSON();
            this.view.info.options.hasMembershipPlan = this.selectedPlan !== null;

            this.view.info.reset();
            this.refreshView();
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModifyPlanAction: function(e) {
            this.model.collection.trigger("payment:modify-plan", this.model);
        },

        onEditMethodAction: function(e) {
            this.model.collection.trigger("payment:add-method", this.model, this.view.info);
        },

        onDeleteMethodAction: function(e) {
            this.model.collection.trigger("payment:delete-method", this.model, this.view.info);
        },

        onShowInvoiceHistory: function(e) {
            this.model.collection.trigger("payment:show-invoice-history", this.model);
        },

        onInvoicHistoryAction: function(e) {
            U.log("Invoice History Action...");
        },

        onCancelMembershipAction: function(e) {
            U.log("Cancel Membership Action...");
        }
    });

    return VPaymentListItem;

});

